import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { sessionService } from '@/providers/services/auth/session';
import { Vue, Component } from 'vue-property-decorator';
import axios from 'axios';
import SearchSelectDropdown from '../search-select-dropdown/search-select-dropdown';

@Component({
    name: 'data-access-filter',
    components: {
        'search-select-dropdown': SearchSelectDropdown,
    },
})

export default class DataAccessFilter extends Vue {

    // -----------------------------------------------------------
    // Properties

    private userCompetencies: any = [];

    private categoryList: any = [];

    private subjectList: any = [];

    private frameworkList: any = [];

    private domainList: any = [];

    private topicList: any = [];

    private gradeList: any = [];

    private competencyList: any = [];

    private selectedCompetencies: any = [];

    private selectedCompetenciesList: any = [];

    private activeCategory: string = '';

    private activeDomain: string = '';

    private activeTopic: string = '';

    private activeGrade: string = '';

    private dateRange: string = '';

    private hoverSubject: any;

    private subjectDropDowntext: string = '';

    private toggleSubjectDropdown: boolean = false;

    private competencyButtonDisable: boolean = true;

    // ------------------------------------------------------------------------------
    // Hooks

    private mounted() {
        this.fetchCategories();
    }

    // ------------------------------------------------------------------------------
    // Actions

    private onSelectCategory(categoryId: string) {
        this.activeCategory = categoryId;
        this.subjectDropDowntext = '';
        this.toggleSubjectDropdown = false;
        this.fetchSubjects(categoryId);
    }

    private onSelectSubject(subjectId: string) {
        this.fetchDomainList(subjectId);
        this.getGradesList(subjectId);

    }

    private onSelectFrameworks(subjectTitle: string, frameTitle: string, subjectId: string) {
        this.subjectDropDowntext = frameTitle + ' ' + subjectTitle;
        this.toggleSubjectDropdown = true;
        this.competencyButtonDisable = false;
        this.activeDomain = '';
        this.activeTopic = '';
        this.onSelectSubject(subjectId);
    }

    private onSelectDomain(domainId: string, index: any) {
        this.activeDomain = domainId;
        const domain = this.domainList.find((item: any) => item.domainCode === domainId);
        this.activeTopic = '';
        this.competencyList = [];
        if (this.activeDomain) {
            this.topicList = domain.topics;
        }
    }

    private onSelectTopic(topicId: string) {
        this.activeTopic = topicId;
        const domainCode = this.activeDomain;
        const userCompetencies = this.userCompetencies;
        const activeDomain = userCompetencies.find((item: any) => item.domainCode === domainCode);
        const activeTopic = activeDomain && activeDomain.topics.find((topic: any) => topic.topicCode === topicId);
        if (this.activeTopic) {
            this.competencyList = activeTopic.competencies;
        }

    }

    private removeTag(competency: string) {
        this.selectedCompetencies.length ? this.selectedCompetencies.pop(competency)
            : this.selectedCompetenciesList.pop(competency);
    }

    private cancelCompetemcySelect() {
        this.activeDomain = '';
        this.activeTopic = '';
        this.topicList = [];
        this.competencyList = [];
        this.selectedCompetencies = [];
        this.$bvModal.hide('modal-competency-picker');
    }

    private saveCompetemcySelect() {
        this.selectedCompetenciesList = [...this.selectedCompetencies];
        this.$bvModal.hide('modal-competency-picker');
    }


    // ------------------------------------------------------------------------------
    // Methods


    private fetchCategories() {
        taxonomyAPI.fetchTaxonomyClassifications().then((categories) => {
            this.categoryList = categories;
        });
    }

    private fetchSubjects(categoryId: string) {
        taxonomyAPI.fetchSubjects(categoryId).then((subjects) => {
            this.subjectList = subjects;
        });
    }

    private fetchDomainList(subjectId: string) {
        const params = {
            subject: subjectId,
        };
        const pathParams = {
            subject: subjectId,
            user: sessionService.getSession()!.user_id,
        };
        axios.all([
            taxonomyAPI.fetchSubjectDomainTopicMetadata(params),
            taxonomyAPI.fetchDomainTopicCompetencyMatrix(pathParams),
        ]).then(axios.spread((domainList, competencyMatrix) => {
            this.domainList = domainList;
            this.userCompetencies = competencyMatrix;
        }));
    }


    private getGradesList(subjectId: any) {
        taxonomyAPI.fetchTaxonomyGrades(subjectId, 'GUT').then((gradesList: any) => {
            this.gradeList = gradesList;
        });
    }

}
